import { TranslocoService } from "@jsverse/transloco";
import { ServerError } from "../../interceptors/http-error-translator.interceptor";

/**
 * Translates the error message using the translation service.
 * @param error The error object.
 */
export const translateServerError = (
    error: ServerError,
    translocoService: TranslocoService,
): string => {
    const { code, params = {} } = error;
    const normalizedCode =
        typeof code === "string"
            ? code.replace(/[_-]/g, ".").toLowerCase()
            : "";
    const translationKey = `serverErrors.${normalizedCode}`;
    const message = translocoService.translate(translationKey, {
        code,
        ...params,
    });
    return message !== translationKey ? message : error.message;
};
